import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import { renderAutoCompleteSingleSelect, renderDateField } from '../../../../components/reduxFields';
import Loader from '../../../../img/loader.gif';
import history from '../../../../history';

class patientAppointmentReport_CBG extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      FromDate: new Date().setDate(new Date().getDate() - 7),
      ToDate: new Date(),
      // iframeURL: `${REPORT_URL}?%2fHC.SqlReports%2fPatientAppointmentReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.props.orgID + '&LocationID=' + this.props.locationID,
      iframeURL: '',
      isLoading: false,
      random: 0,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
  }

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({
      [input.name]: value,
    });
  }

  appointmentFilterByDate = (formData) => {
    this.resetIframe();

    let FromDateFormat;
    let ToDateFormat;
    // console.log('formData.legth---', Object.keys(formData).length);
    if (Object.keys(formData).length) {
      FromDateFormat = moment(this.state.FromDate).format('YYYY-MM-DD');
      ToDateFormat = moment(this.state.ToDate).format('YYYY-MM-DD');
    } else {
      let DateFormat = new Date().setDate(new Date().getDate() - 7);
      FromDateFormat = moment(DateFormat).format('YYYY-MM-DD');
      let dateFormat = new Date();
      ToDateFormat = moment(dateFormat).format('YYYY-MM-DD');
    }
    let REPORT_URL  = GetReportUrl(this.props.agencyName);  
    let reportName = base64Encode('CL_PA_CBG_RPT');
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "FromAppointmentDate","Value": "`+ FromDateFormat + `"},{"Name": "ToAppointmentDate","Value": "`+ ToDateFormat + `"},{"Name": "LocationID","Value": "`+ (formData.location || 0) + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false});
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  
  renderReport() {
    return (
      <Iframe url={this.state.iframeURL}
        // width="450px"
        height="580px"
        id="myId"
        className="manual_report"
        display="initial"
        position="relative"
        onLoad={(e)=> this.onLoadReport(e)}
        key={this.state.random}
        allowFullScreen />
    );
  }

  handleChange = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/scheduling-reports');
  }
  render() {
    const { handleSubmit } = this.props;
    //   let iframeUrl = `${REPORT_URL}?%2fHC.SqlReports%2fPatientAppointmentReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.state.organizationID + '&LocationID=' + this.state.locationID;
    // let windowsHeight = window.innerHeight + 159 + "px";
    // console.log(windowsHeight);
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Scheduling {' > '} Appointment Report</h2>
        :
          <h2 className="page_title">Appointment Report</h2>
        }  
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>}
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-3 mt-35">
                  <Field name="location"
                    label="Location"
                    handleNewRequest={this.handleChange}
                    options={this.props.userLocationList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-3">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection={true}
                    component={renderDateField} />

                </div>
                <div className="col-sm-3">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    // minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    onDateChange={this.onDateChange}
                    component={renderDateField} />
                </div>
                <div className="col-sm-3 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        {this.renderReport()}
      </div>
    );
  }
}

patientAppointmentReport_CBG = reduxForm({
  form: 'patientAppointmentReport_CBGForm',
})(patientAppointmentReport_CBG);

function mapStateToProps(state) {
  let locationArr = [];
  if (state.login.userLocationList) {
    locationArr = (state.login.userLocationList).map((obj) => {
      return (
        {
          id: obj.id,
          value: obj.locationName,
        }
      );
    });
  }

  return {
    orgID: state.login.loginUserInfo.organizationID,
    userLocationList: locationArr,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, {})(patientAppointmentReport_CBG);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/SchedulingReports/patientAppointmentReport_CBG.js